module.exports = __webpack_public_path__ + "static/img/close_btn.4ff3aa7b.png";